import script from "./editRoute.vue?vue&type=script&setup=true&lang=ts"
export * from "./editRoute.vue?vue&type=script&setup=true&lang=ts"

import "./editRoute.vue?vue&type=style&index=0&id=0dd6ebb2&lang=css"

const __exports__ = script;

export default __exports__